import { SECTIONS } from "../../constants/sections";
import {
    hasTrending,
    getTrendingSection,
    getSection,
} from "../../utils/trending";
import { removeUrlDomain } from "../../utils/path/library";
import log from "../../utils/logger/library";
import { DEFAULT_MAX_ITEMS } from "./constants";
import { useRef, useState, useEffect } from "react";

export const createList = (items, section) => {
    const showTrendingCount = Boolean(SECTIONS[section].showTrendingCount);
    return items
        .filter((item) => item.hasOwnProperty("count"))
        .sort((a, b) => b.count - a.count)
        .map((item, index) => {
            const href = removeUrlDomain(item.href);
            const count = showTrendingCount ? item.count : 0;
            return {
                ...item,
                rank: index + 1,
                section: section,
                href: href,
                count: count,
            };
        });
};

const getTrendingSectionName = (section) => {
    const name = getTrendingSection(section);
    return hasTrending(section) && name
        ? Promise.resolve(name)
        : Promise.reject(`Section ${section} not defined`);
};

export const fetch = (section) => {
    return getTrendingSectionName(section)
        .then((name) => getSection(name, DEFAULT_MAX_ITEMS))
        .then((items) => createList(items, section));
};

const fetchHOC = (Component, originalSection = "") => {
    return ({
        section = originalSection,
        hideSectionLabel,
        trendingHeaderOverride = null,
        cardClickHandler = null,
        className = "",
    }) => {
        const abort = useRef(null);
        const [items, setItems] = useState([]);

        useEffect(() => {
            abort.current = false;
            fetch(section)
                .then((nextItems) => !abort.current && setItems(nextItems))
                .catch((error) => {
                    log.error("(TrendingList) Failed to fetch", error);
                    !abort.current && setItems([]);
                });
            return () => {
                abort.current = true;
            };
        }, [section]);

        if (items.length < DEFAULT_MAX_ITEMS) return null;
        return (
            <Component
                items={items}
                section={section}
                hideSectionLabel={hideSectionLabel}
                trendingHeaderOverride={trendingHeaderOverride}
                cardClickHandler={cardClickHandler}
                className={className}
            />
        );
    };
};

export default fetchHOC;
